import 'devextreme/dist/css/dx.common.css';

import ruMessages from "devextreme/localization/messages/ru.json";
import trMessages from "devextreme/localization/messages/tr.json";
import enMessages from "devextreme/localization/messages/en.json";
import { locale, loadMessages } from "devextreme/localization";

import * as glb from './globals';
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';

import { AuthProvider, useAuth } from './contexts/auth';
import { TabProvider } from './contexts/tab-navigation';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import ReleaseVersionWatcher from './components/ReleaseVersionWatcher';
import NotificationSocketBridge from './components/NotificationSocketBridge';
import SyncBootstrap from './components/SyncBootstrap';

function App() {
  const { user, loading } = useAuth();

  loadMessages(trMessages);
  loadMessages(ruMessages);
  loadMessages(enMessages);
  
  
  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    // Apply user's compact theme early to avoid flash of default spacing
    try {
      const applyCompactTheme = (file) => {
        try {
          const id = 'dx-compact-theme';
          let link = document.getElementById(id);
          if (!file) {
            if (link) link.parentNode.removeChild(link);
            return;
          }
          if (!link) {
            link = document.createElement('link');
            link.rel = 'stylesheet';
            link.id = id;
            document.head.appendChild(link);
          }
          if (!link.href || !link.href.endsWith(file)) link.href = file;
        } catch (e) { /* ignore */ }
      };

      const mapThemeToCompactFile = (theme) => {
        if (!theme) return null;
        const t = (''+theme).toLowerCase();
        // strip possible prefixes like 'dx.'
        const name = t.replace(/^dx\./, '');
        const known = ['light','dark','carmine','softblue','darkmoon','darkviolet','greenmist','contrast'];
        if (known.indexOf(name) >= 0) return `${process.env.PUBLIC_URL}/themes/dx.${name}.compact.css`;
        // fallback: if the theme already looks like a compact filename, use it
        if (t.indexOf('.compact.css') > -1) return `${process.env.PUBLIC_URL}/themes/${t.split('/').pop()}`;
        return null;
      };

      // priority: localStorage override -> user.apptheme -> glb default
      let file = null;
      try { file = window.localStorage && window.localStorage.getItem('appCompactTheme'); } catch(e) { file = null; }
      if (!file) {
        const utheme = (user && user.apptheme) ? user.apptheme : (glb && glb.default && glb.default.KULLANICI && glb.default.KULLANICI.apptheme ? glb.default.KULLANICI.apptheme : null);
        file = mapThemeToCompactFile(utheme);
      }
      if (file) {
        try { if (window.localStorage) window.localStorage.setItem('appCompactTheme', file); } catch(e){}
        applyCompactTheme(file);
      }
    } catch (e) { console.error(e); }

    Intl.DateTimeFormat().resolvedOptions().timeZone = 'Europe/Istanbul';
    locale(!user.KUL_DILKOD ? 'tr' : user.KUL_DILKOD+'-'+user.KUL_DILKOD.toUpperCase());
    return (
      <>
        <NotificationSocketBridge />
        <SyncBootstrap />
        <Content />
      </>
    );
  }

  return <UnauthenticatedContent />;
}
// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <AuthProvider>
        <TabProvider>
          <div className={`app ${screenSizeClass}`}>
            <ReleaseVersionWatcher />
            <App />
          </div>
        </TabProvider>
      </AuthProvider>
    </Router>
  );
}
